module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "物联卡充值二维码",
      "visible": _vm.cardQrcodeVisible,
      "close-on-click-modal": false,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.cardQrcodeVisible = $event
      }
    }
  }, [_c('qrcode', {
    staticClass: "qrcode",
    attrs: {
      "value": _vm.url
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-saoma",
    staticStyle: {
      "font-size": "24px",
      "vertical-align": "middle"
    }
  }), _vm._v("   请打开 "), _c('span', {
    staticClass: "iconfont icon-weixindenglu",
    staticStyle: {
      "font-size": "16px",
      "vertical-align": "middle",
      "color": "#00c800"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#0099cb"
    }
  }, [_vm._v("微信APP扫码")]), _vm._v(" 支付物联网卡费用")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-35937360!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/card_buyflow.vue
// module id = 737
// module chunks = 2